import { render } from "./BrandFilter.vue?vue&type=template&id=b616a700&scoped=true"
import script from "./BrandFilter.vue?vue&type=script&lang=js"
export * from "./BrandFilter.vue?vue&type=script&lang=js"

import "./BrandFilter.vue?vue&type=style&index=0&id=b616a700&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b616a700"]])

export default __exports__